import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "BannerWidget BestFitBannerWrapper js-Widget" }
const _hoisted_2 = { class: "DesktopWidget CheckMatchIpadText BannerWidgetBackground" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "HeadingWrapper" }, [
        _createElementVNode("h2", { class: "IncentiveHeading" }, "How well do you fit this programme?"),
        _createElementVNode("h2", { class: "IncentiveSubHeading" }, [
          _createTextVNode(" Find out with our "),
          _createElementVNode("strong", null, "BestFit"),
          _createTextVNode(" tool! ")
        ])
      ], -1 /* HOISTED */)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        alt: "Check your match with this programme",
        src: "https://monet-prtl-co.imgix.net/Shared/BestFit/bestfit_banner_desktop.svg",
        loading: "lazy",
        width: "229",
        height: "151"
      }, null, -1 /* HOISTED */)),
      _createElementVNode("button", {
        class: "DriverButton Blue",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
      }, [
        (_ctx.isFillingProfile || (_ctx.isFullProfile && !_ctx.userLoggedIn))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Continue answering ")
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Check your match! ")
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _createElementVNode("button", {
      class: "MobileWidget DriverButton",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
    }, [
      (_ctx.isFillingProfile || (_ctx.isFullProfile && !_ctx.userLoggedIn))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Continue answering ")
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Check your match! ")
          ], 64 /* STABLE_FRAGMENT */)),
      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-arrow-right" }, null, -1 /* HOISTED */))
    ])
  ]))
}